import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';
import DeleteIcon from 'material-ui-icons/Delete';
import EnableIcon from 'material-ui-icons/CheckCircle';
import DisableIcon from 'material-ui-icons/VisibilityOff';
import ViewIcon from 'material-ui-icons/Visibility';
import BlockDeleteDialog from './BlockDeleteDialog';
import {
    deleteBlock,
    disableBlock,
    enableBlock
} from './thunks';
import {
    canEditOrViewGlobal,
    showDeleteGlobalButton,
    showEnableDisableButton,
    showViewGlobalButton
} from '../../components/permissions/permissions';

class BlocksGridActions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            block: null
        };
    }

    handleDisableBlock = (block) => {
        this.props.disableBlock(block)
    };

    handleEnableBlock = (block) => {
        this.props.enableBlock(block)
    };

    handleClickOpen = (block) => {
        this.setState({
            open: true,
            block: block
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
            block: null
        });
    };

    deleteBlock = (block) => {
        this.props.deleteBlock(this.state.block);
        this.setState({
            open: false,
            block: null
        });
    };

    render() {
        const {props} = this.props;

        const EditButton = () => (
            <span>
                <Link to={"/blocks/" + props.row.id}>
                <Tooltip title="Edit Block">
                    <IconButton className="smallIconButton editColor">
                        <EditIcon />
                    </IconButton>
                </Tooltip>
                </Link>{' '}
            </span>
        )

        const ViewButton = showViewGlobalButton(() =>
            <span>
                <Link to={"/blocks/" + props.row.id}>
                <Tooltip title="View Block">
                    <IconButton className="smallIconButton viewColor">
                        <ViewIcon />
                    </IconButton>
                </Tooltip>
                </Link>{' '}
            </span>
        )

        const EditOrViewBlock = canEditOrViewGlobal(EditButton, ViewButton);

        const EnableDisableBlockButton = showEnableDisableButton(() =>
            <span>
                {props.row.is_enabled ?
                    <Tooltip title="Disable Block">
                        <IconButton className="smallIconButton disableColor" onClick={e => this.handleDisableBlock(props.row.id)}>
                            <DisableIcon />
                        </IconButton>
                    </Tooltip> :
                    <Tooltip title="Enable Block">
                        <IconButton className="smallIconButton enableColor" onClick={e => this.handleEnableBlock(props.row.id)}>
                            <EnableIcon />
                        </IconButton>
                    </Tooltip>
                }
            </span>
        )

        const DeleteBlockButton = showDeleteGlobalButton(() =>
            <span>
                <Tooltip title="Delete Block">
                    <IconButton className="smallIconButton deleteColor" onClick={e => this.handleClickOpen(props.row.id)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )

        return(
            <span>
                <EditOrViewBlock />
                <EnableDisableBlockButton />
                <DeleteBlockButton />
                <BlockDeleteDialog
                    open={this.state.open}
                    handleSubmit={this.deleteBlock.bind(this)}
                    handleRequestClose={this.handleRequestClose}
                />
            </span>
        )
    }
}

const mapStateToProps = (state, props) => ({});

export default connect(mapStateToProps, {
    deleteBlock,
    disableBlock,
    enableBlock
})(BlocksGridActions);


// WEBPACK FOOTER //
// ./src/containers/blocks/BlocksGridActions.jsx